<template>
    <div class="">
        <ctlHomeNav></ctlHomeNav>
        <v-layout row v-if="error">
            <v-flex xs12>
                <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
            </v-flex>
        </v-layout>     
        <v-container fluid >
            <ctlItemProductNav></ctlItemProductNav>
            <v-layout align-start wrap>
                <v-flex xs12>
                    <v-card class="elevation-12">
                    <v-toolbar dark color="secondary">
                        <v-spacer></v-spacer>
                        <v-toolbar-title>Item / Product Search</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <!-- <v-btn color="primary" class="white--text"
                            href="http://www.healthmarkmedia.com/productlist.php" target="_blank">
                            <v-icon left dark>cloud_upload</v-icon> 
                            Product Catalog
                        </v-btn> -->
                    </v-toolbar>
                    <v-card-text>
                        <ctlItemAdvancedSearchFilter @onSearchParamsChanged="onSearchParamsChanged"></ctlItemAdvancedSearchFilter>
                    </v-card-text>
                    <v-card-text v-if="items.length">
                        <ctlItemAdvancedSearchCardView 
                            class="hidden-sm-and-up"
                            :items="items"
                            @onItemPicked="viewQuote"
                            ></ctlItemAdvancedSearchCardView>
                        <ctlItemAdvancedSearchTableView 
                            class="hidden-xs-only"
                            :items="items"
                            @onItemPicked="viewQuote"
                            ></ctlItemAdvancedSearchTableView>

                        <div class="text-xs-center">
                            <v-pagination
                            v-model="searchCriteria.page"
                            :length="pages"
                            circle
                            ></v-pagination>
                        </div>
                    </v-card-text>
                    <v-card-text v-else>
                        <v-layout row>
                            <v-alert value="true" color="warning" body-2 outline>No Record Found</v-alert>
                        </v-layout>
                    </v-card-text>

                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <!-- {{userData}} -->
    </div>


</template>
<script>
// import _ from 'lodash'
// import jobTypeApi from '@/api/jobTypeApi'
import ctlItemAdvancedSearchFilter from '@/components/ctlItemAdvancedSearchFilter'
import ctlItemAdvancedSearchTableView from '@/components/ctlItemAdvancedSearchTableView'
import ctlItemAdvancedSearchCardView from '@/components/ctlItemAdvancedSearchCardView'
import ctlHomeNav from '@/components/ctlHomeNav'
import ctlItemProductNav from '@/components/ctlItemProductNav'
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
    components: {
        'ctlItemAdvancedSearchFilter': ctlItemAdvancedSearchFilter,
        'ctlItemAdvancedSearchTableView': ctlItemAdvancedSearchTableView,
        'ctlItemAdvancedSearchCardView': ctlItemAdvancedSearchCardView,
        'ctlHomeNav': ctlHomeNav,
        'ctlItemProductNav': ctlItemProductNav
        },
    data: () => ({
        searchCriteria: {
            // statusSelected: [1, 5],
            // jobTypeSelected: 0
        },
        pages: null,
        items: [],

    }),
    computed: {
        ...mapGetters('auth',[
            'loggedIn',
            'userData',
            'userHasPublicRole',
            'userHasInternalRole',
        ]),
        error () {
            return this.$store.getters.error
        },
        loading () {
            return this.$store.getters.loading
        }
    },
    watch: {
        searchCriteria: {
            handler: async function (newVal, oldVal) {
                console.log(`${newVal.page} === ${oldVal.page}`)
                // if page not changes, it means the search fired from other search filters
                // so I need reset page = 1
                if(oldVal && newVal.page === oldVal.page) {
                    // newVal.page = 1
                }
                await this.searchItems()
            },
            deep: true
        },
        userIsAuthenticated (value) {
            if (!value) {
                this.$router.push('/')
            }
        }
    },
    methods: {
        ...mapActions('itemSearch',[
            'searchItemAdvanced'
        ]),
        ...mapMutations('itemSearch',[
            'setUserItemAdvancedSearchParams'
        ]),
        async onSearchParamsChanged (paras) {
            this.searchCriteria = Object.assign({}, paras)
            
        },
        async searchItems () {
            const searchResult = await this.searchItemAdvanced(this.searchCriteria)
            this.items = searchResult.records
            this.pages = searchResult.pageCount
            this.setUserItemAdvancedSearchParams(this.searchCriteria)
        },
        jobColor (jobStatus) {
            if (jobStatus === 'Cancelled') {
                return 'red--text lighten-3'
            }
            if (jobStatus === 'Lost') {
                return 'red--text lighten-3'
            }
            if (jobStatus === 'NeedMoreInfo') {
                return 'orange--text lighten-3'
            }
            if (jobStatus === 'Editing') {
                return 'blue--text lighten-3'
            }
            if (jobStatus === 'Processing' 
                || jobStatus === 'DiscountApproved') {
                return 'blue--text lighten-3'
            }
            if (jobStatus === 'Revising') {
                return 'blue--text lighten-3'
            }
            if (jobStatus === 'Won') {
                return 'green--text lighten-3'
            }
            if (jobStatus === 'SentToCustomer') {
                return 'purple--text lighten-3'
            }
            if (jobStatus === 'WaitingForProcess') {
                return 'blue--text lighten-3'
            }
        },
        viewQuote: function (id) {
            // console.table(job)
            if(this.userHasInternalRole) {
                this.$router.push({ name: 'int-quote-board', params: { id: id } })
            } else {
                this.$router.push({ name: 'pub-quote-board', params: { id: id } })

            }
        },
        newQuote: function () {
            // console.log('open pub-quote-new')
            this.$router.push({ name: 'pub-quote-new' })
        },
        onDismissed () {
            // console.log('onDismissed alert')
            // this.$store.dispatch('clearError')
        }
    },
    created: async function () {

    },
    mounted: function () {
        // this.searchItems()
        console.log('this.userHasInternalRole' + this.userHasInternalRole)
        console.log('this.userHasPublicRole' + this.userHasPublicRole)

    },

    destroyed: function () {
        this.onDismissed()
    }
}
</script>
